import ApiBase from '../ApiBase';

class Download extends ApiBase {
    route = '/exhibitors/downloads';

    /**
     * @method storeDownload
     * @param {object} data
     * @return {Promise<*>}
     */
    storeDownload = async (data) => {
        return this.post(this.route, data);
    }

    /**
     * @method updateDownload
     * @param {string} id
     * @param {object} data
     * @return {Promise<*>}
     */
    updateDownload = async (id, data) => {
        return this.patch(this.route+'/' +id, data);
    }
}

export default new Download();
